import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { marginAttributes } from '../../system/attributes';
import { getPropsBlocker } from '../../utils';

var themeStyle = function themeStyle(_ref) {
  var Tabs = _ref.theme.componentOverrides.Tabs,
      wide = _ref.wide;

  if (wide) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            width: 100%;\n            justify-content: space-evenly;\n\n            ", "\n        "])), Tabs.Root.base);
  }

  return Tabs.Root.base;
};

export var TabsRoot = styled.div.withConfig(getPropsBlocker())(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    align-items: start;\n    display: flex;\n    flex-wrap: wrap;\n    width: fit-content;\n\n    ", "\n    ", "\n"])), themeStyle, marginAttributes);